/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { KpiTypes } from "~/generated/graphql";
import { TARGET_TYPE } from "~/components/Charts/types";

export enum KpiType {
  COST_ALLOCATION_COVERAGE = "costAllocation",
  OVERALL_WASTE = "overallWaste",
  NON_PROD_HOURS = "nonProdHours",
}

type KpiTypeOption = {
  value: KpiType;
  valueLabel: string;
  label: string;
  description: string;
  targetType: TARGET_TYPE;
};

const KpiTypeOptions: KpiTypeOption[] = [
  {
    value: KpiType.COST_ALLOCATION_COVERAGE,
    valueLabel: "Allocated Cost",
    targetType: TARGET_TYPE.negative,
    label: "Cost Allocation Coverage",
    description:
      "Allows to track the percentage of Environment costs allocated to Business Context. For each Business Context, we record a daily value of % of the allocated total cost",
  },
  {
    value: KpiType.NON_PROD_HOURS,
    valueLabel: "Current Shutdown Time",
    targetType: TARGET_TYPE.negative,
    label: "Non-Production Environments Shutdown Time",
    description:
      "Measures how many hours a week your development environments are turned off. This KPI will allow you to avoid paying for idle workloads",
  },
  {
    value: KpiType.OVERALL_WASTE,
    valueLabel: "Current Waste",
    targetType: TARGET_TYPE.positive,
    label: "Overall Waste",
    description:
      "Allows to track the percentage of waste generated by applications and their environments over total spend. We record a daily value of % of the allocated total cost for each Organizational Unit",
  },
];

export const enum KpiStatus {
  PLANNED = "planned",
  IN_PROGRESS = "in progress",
  ACHIEVED = "achieved",
}

export function getKpiType(type: string) {
  return (
    KpiTypeOptions.find((element) => element.value === type) ?? {
      label: "",
      description: "",
      valueLabel: "",
      targetType: TARGET_TYPE.negative,
    }
  );
}

export function mapKpiType(type: KpiType) {
  switch (type) {
    case KpiType.COST_ALLOCATION_COVERAGE:
      return KpiTypes.CostAllocationCoverage;
    case KpiType.NON_PROD_HOURS:
      return KpiTypes.NonProdHours;
    case KpiType.OVERALL_WASTE:
      return KpiTypes.OverallWaste;
    default:
      throw new Error("Unsupported kpi type");
  }
}
